<div id="add-station" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Ajouter une nouvelle<br>station
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Nom de la station</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="station.name" (ngModelChange)="validator()" placeholder="Comédie"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Adresse</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="station.address" (ngModelChange)="validator()" placeholder="3 Place Paul Bec"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Ville</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="station.zipCode" (ngModelChange)="validator()" placeholder="34070"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text" style="width: 50px;">
                            <input [(ngModel)]="station.city" (ngModelChange)="validator()" placeholder="Montpellier"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text" style="width: calc(100% - 60px); margin-left: 10px;">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Latitude</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="station.latitude" (ngModelChange)="validator()" placeholder="43.605225"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                    <div class="uk-margin">
                        <label class="label">Longitude</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="station.longitude" (ngModelChange)="validator()" placeholder="3.877979"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked" *ngIf="session.role.ability === 'super-admin'">
                    <div class="uk-margin">
                        <label class="label">Adhérant</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <select class="combo-list alt color-cold-grey bold uk-width-1-1"
                                [(ngModel)]="selectedSocietyId" (ngModelChange)="validator()">
                                <option [value]="0" disabled>Sélectionner un adhérant</option>
                                <option *ngFor="let s of societies" [value]="s.Id">
                                    {{ s.Name }} ({{ s.Code }})
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="validated === false" (click)="submit()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div>